
import { mapGetters, mapMutations } from 'vuex'

export default {
    props: {
        autopadding: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        ...mapGetters([
            'isBusy',
            'survey',
            'isSurveyRoute',
            'alertsFaIconsVariantsMap',
            'alertsTitlesVariantsMap',
            'alerts'
        ])
    },
    methods: {
        ...mapMutations(['clearAlert'])
    }
}
